import axios from 'axios'
import { baseURL } from '@/utils/getawayModule'

/**
 * 自定义上传图片插件
 */
class MyUploadAdapter {
  constructor(loader) {
    this.loader = loader
  }

  async upload() {
    const data = new FormData()
    data.append('file', await this.loader.file)

    const res = await axios({
      url: `${baseURL.userApi}/file/upload`,
      method: 'POST',
      data,
      withCredentials: true
    })
    let url = `${res.data.data.realPath}`
    return {
      default: url
    }
  }
}

export default MyUploadAdapter
